import React, { useState } from 'react';
import { Menu, X, Sparkles } from 'lucide-react';
import { WorkiumLogo } from './WorkiumLogo';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'How it works',
    href: '#how-it-works'
  }];
  return <header className="sticky top-0 z-50 w-full backdrop-blur-md bg-white/5 border-b border-white/10" data-id="element-268">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-269">
        <div className="flex items-center justify-between h-16" data-id="element-270">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-271">
            <a href="#" aria-label="Workium AI Home" data-id="element-272">
              <WorkiumLogo size="md" data-id="element-273" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-274">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-275">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-4" data-id="element-276">
            <a href="#demo" className="text-sm font-medium text-slate-300 hover:text-white transition-colors px-4 py-2 rounded-lg hover:bg-white/5" data-id="element-277">
              Join Wishlist
            </a>
            <a href="#demo" className="flex items-center gap-2 text-sm font-medium bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-500 transition-all hover:shadow-[0_0_20px_-5px_rgba(99,102,241,0.5)]" data-id="element-278">
              <Sparkles className="w-4 h-4" data-id="element-279" />
              Request a Demo
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-280">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-400 hover:text-white p-2" aria-label="Toggle menu" data-id="element-281">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-282" /> : <Menu className="w-6 h-6" data-id="element-283" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-slate-900 border-b border-white/10 px-4 pt-2 pb-6 space-y-4" data-id="element-284">
          <nav className="flex flex-col space-y-4" data-id="element-285">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-slate-300 hover:text-white block" data-id="element-286">
                {link.name}
              </a>)}
          </nav>
          <div className="flex flex-col gap-3 pt-4 border-t border-white/10" data-id="element-287">
            <a href="#demo" onClick={() => setIsMobileMenuOpen(false)} className="text-center text-base font-medium text-slate-300 hover:text-white py-2 border border-slate-700 rounded-lg" data-id="element-288">
              Join Wishlist
            </a>
            <a href="#demo" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-center gap-2 text-base font-medium bg-indigo-600 text-white py-2 rounded-lg" data-id="element-289">
              <Sparkles className="w-4 h-4" data-id="element-290" />
              Request a Demo
            </a>
          </div>
        </div>}
    </header>;
}